import {
  exchangeAESKeyUsecase,
  hasSecureAesKey,
  initializeInstances,
} from "@/init/initializeInstances";
import { getUserRoleFromCookie } from "@/utils/cookie-utils";
import { Rx } from "./reactive-state-manager";

export class InitializationStateManager {
  //MARK:- Properties
  private static instance: InitializationStateManager;
  private isInProgressInitialization = false;

  public isCompletedInitialization = new Rx<boolean>(false);

  private constructor() {}

  public static getInstance(): InitializationStateManager {
    if (!InitializationStateManager.instance) {
      InitializationStateManager.instance = new InitializationStateManager();
    }
    return InitializationStateManager.instance;
  }

  public async startInitialization() {
    if (this.isInProgressInitialization) {
      return;
    }
    this.isInProgressInitialization = true;

    await initializeInstances();
    // 화면이 렌더되기 전에 암호화 채널을 복구한다 — 화면 렌더 후에 하면
    // 각 화면의 첫 /s/ 요청과 경합해 FailToGetSecretKey(300208)가 발생한다.
    await this.restoreEncryptedChannelIfNeeded();
    InitializationStateManager.getInstance().isCompletedInitialization.set(true);
  }

  /**
   * AES 세션키 복구 (새 탭/새 문서 대응)
   *
   * AES 세션키는 탭 단위 sessionStorage 에 저장되므로, 로그인된 브라우저라도
   * 새 탭/새 문서(예: 이용권 스토어에서 '치료 등록하러 가기'로 복귀)에서는 키가 없다.
   * 로그인 흔적(역할 쿠키)이 있으면 로그인 때와 동일하게 쿠키 기반으로 키를 재교환해
   * `/s/` 암호화 채널을 복구한다. 실패해도 여기서 막지 않는다 — 이후 화면의
   * 인증 가드/요청 실패가 기존 정책대로 로그인으로 유도한다.
   */
  private async restoreEncryptedChannelIfNeeded(): Promise<void> {
    try {
      if (await hasSecureAesKey()) {
        return;
      }
      const userRole = await getUserRoleFromCookie();
      if (!userRole) {
        return;
      }
      console.log("[InitializationStateManager] :: AES 세션키 없음 — 쿠키 기반 재교환 시도");
      const result = await exchangeAESKeyUsecase.execute();
      if (result.isFailure) {
        console.error(
          "[InitializationStateManager] :: AES 세션키 재교환 실패 (로그인 유도는 화면 가드가 처리)",
          result.error
        );
        return;
      }
      console.log("[InitializationStateManager] :: AES 세션키 복구 완료");
    } catch (error) {
      console.error("[InitializationStateManager] :: AES 세션키 복구 중 오류", error);
    }
  }
}
